import { createContext } from 'react'
import { PaperOptedInContextType } from '../types'

export const PaperOptedInContext = createContext<PaperOptedInContextType | null>(
  null
)
